import React from "react";
import IconCheck from "../../Resources/svg/Icons/IconCheck";
import IconBack from "../../Resources/svg/Icons/IconBack";

interface Step {
  id: number;
  title: string;
  active: boolean;
}

interface InterfaceNavForm {
  steps: Step[];
  onClick: (id: Number) => void;
  activeStep: Step;
  title: any;
  onBack: () => void;
}

export const NavForm = ({
  steps,
  onClick,
  activeStep,
  title,
  onBack,
}: InterfaceNavForm) => {
  return (
    <div className="nav-form">
      <div
        className="nav-form__routing"
        style={{ background: "rgb(227, 230, 250)" }}
      >
        <div className="flex gap-lg">
          <div>
            <IconBack onClick={onBack} />
          </div>
          <div className="flex col gap-lg">
            <span className="nav-form__title">{title}</span>
            <div className="nav-form__border">
              <ul>
                {steps.map(({ id, title, active }) => (
                  <li
                    className={` ${active ? "disabledNav" : "li-active"} ${
                      activeStep.id <= id
                        ? "nav-form__relative"
                        : " nav-form__before"
                    }`}
                    key={title}
                    onClick={() => (activeStep.id >= id ? onClick(id) : null)}
                  >
                    <div className="nav-form__link">
                      <div
                        className={
                          "circle-default" +
                          (activeStep.id == id ? " circle-active" : "") +
                          (activeStep.id <= id ? " " : " circle-radius")
                        }
                      >
                        {activeStep.id <= id ? id : <IconCheck />}
                      </div>
                      <div
                        className={`form-hover ${
                          activeStep.id == id ? "form-active" : ""
                        }`}
                      >
                        {activeStep.id <= id ? (
                          title
                        ) : (
                          <span data-test="test-li" className="form-active">
                            {title}
                          </span>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
